import { render } from "./LogbookEntry.vue?vue&type=template&id=c4d8e044"
import script from "./LogbookEntry.vue?vue&type=script&lang=js"
export * from "./LogbookEntry.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__